/* Romaccio - geeft elke productfoto zijn eigen achtergrondkleur.

   Waarom dit bestaat. Het vak waarin een productfoto staat heeft een vaste
   verhouding, de foto's zelf niet: er zitten staande foto's van 746x926 tussen
   en vierkante detailfoto's van 746x746. De vulling staat op 'contain', zodat
   er niets wordt weggesneden - maar dan blijft er boven en onder een strook
   over.

   Die strook had een vaste kleur: #683e22, een donkerbruin dat paste bij de
   fotoachtergronden van de andere winkel. Bij Romaccio zijn die achtergronden
   licht: 96 hoekpixels bemonsterd over acht producten geeft mediaan #cbbdad,
   en 71% van de hoeken is licht. Dat bruin stond er dus als een balk omheen.

   Een nieuwe vaste kleur lost het niet op, want je achtergronden lopen van
   grijs over beige naar perzik. Daarom leest dit script per foto de vier
   hoeken uit en zet die kleur achter die ene foto. De strook valt dan weg
   tegen de foto zelf, welke kleur die ook heeft.

   Lukt het uitlezen niet - geen canvas, geen CORS, foto nog niet geladen -
   dan gebeurt er niets en blijft de neutrale kleur uit
   snippets/ai-css-productpagina.liquid staan. Breekt dus nooit iets.

   Door Claude gebouwd, veilig te verwijderen: haal de scriptregel voor
   ai-fotokleur uit snippets/ai-hoofd.liquid en gooi dit bestand weg. */
(function () {
  'use strict';

  var VAK = '.product-information__media .product-media-container';
  var gedaan = new WeakMap();

  /* Shopify's CDN levert elke foto ook in het klein. 40px is ruim genoeg om
     een egale achtergrond te bemonsteren en is een verwaarloosbare download. */
  function klein(src) {
    if (!src) return null;
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=40';
  }

  /* De vier hoeken uitlezen en daar de middelste twee van nemen. Zo telt een
     hoek waar toevallig een arm of een schaduw in valt niet mee. */
  function hoekkleur(afb) {
    var c = document.createElement('canvas');
    var b = 20;
    c.width = b;
    c.height = b;
    var x = c.getContext('2d', { willReadFrequently: true });
    if (!x) return null;
    x.drawImage(afb, 0, 0, b, b);
    var punten = [[1, 1], [b - 2, 1], [1, b - 2], [b - 2, b - 2]];
    var r = [], g = [], bl = [];
    for (var i = 0; i < punten.length; i++) {
      var d = x.getImageData(punten[i][0], punten[i][1], 1, 1).data;
      if (d[3] < 200) return null;            /* doorzichtige hoek: niets te meten */
      r.push(d[0]); g.push(d[1]); bl.push(d[2]);
    }
    function midden(a) {
      a.sort(function (p, q) { return p - q; });
      return Math.round((a[1] + a[2]) / 2);
    }
    return 'rgb(' + midden(r) + ', ' + midden(g) + ', ' + midden(bl) + ')';
  }

  function behandel(vak) {
    var afb = vak.querySelector('img');
    if (!afb) return;
    var src = afb.currentSrc || afb.getAttribute('src');
    if (!src) return;
    if (gedaan.get(vak) === src) return;
    gedaan.set(vak, src);

    var klon = new Image();
    klon.crossOrigin = 'anonymous';
    klon.onload = function () {
      var kleur = null;
      try { kleur = hoekkleur(klon); } catch (e) { kleur = null; }
      if (kleur && gedaan.get(vak) === src) {
        vak.style.setProperty('background-color', kleur, 'important');
      }
    };
    klon.onerror = function () { /* stil: de neutrale kleur blijft staan */ };
    klon.src = klein(src);
  }

  function rond() {
    var vakken = document.querySelectorAll(VAK);
    for (var i = 0; i < vakken.length; i++) behandel(vakken[i]);
  }

  var wacht = null;
  function plan() {
    if (wacht) return;
    wacht = setTimeout(function () { wacht = null; rond(); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rond);
  } else {
    rond();
  }

  /* De galerij wordt opnieuw opgebouwd bij een kleurwissel, en foto's verderop
     laden pas later in. Allebei moeten ze alsnog hun kleur krijgen. */
  new MutationObserver(plan).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', plan);
})();
